/**
 * This file creates the interface definitions for the Jarvis Storage Plugin.
 * The Storage Plugin allows clients to store and retrieve files.
 *
 * This specification only intends to define the Typescript interface that a web app uses,
 * and does not define any native/platform-specific APIs.
 * @packageDocumentation
 * @module StoragePlugin
 */
/**
 * Enumerates different types of errors
 */
export var StorageErrorType;
(function (StorageErrorType) {
    /**
     * Either retrieval or storage failed due to the format of the file
     */
    StorageErrorType["invalidFileFormat"] = "invalidFileFormat";
    /**
     * Device does not have sufficient storage to store the file
     */
    StorageErrorType["insufficientStorage"] = "insufficientStorage";
    /**
     * File size is too large
     */
    StorageErrorType["fileTooLarge"] = "fileTooLarge";
    /**
     * User already wrote a file with the existing name
     */
    StorageErrorType["fileWithNameExists"] = "fileWithNameExists";
    /**
     * Unknown error occurred
     */
    StorageErrorType["unknownError"] = "unknownError";
    /**
     * Invalid options passed into plugin method.
     */
    StorageErrorType["invalidOptions"] = "invalidOptions";
    /**
     * The token passed into the restore file method was invalid.
     */
    StorageErrorType["invalidToken"] = "invalidToken";
})(StorageErrorType || (StorageErrorType = {}));
//# sourceMappingURL=storage.js.map